import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

import { clientExists } from './validator';
import { DocumentType, GetClientByDocumentUseCase } from '../../../core';

// noinspection JSAnnotator
@Directive({
    selector: '[clientExists][formControlName],[clientExists][formControl],[clientExists][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ClientExistsValidatorDirective),
            multi: true,
        },
    ],
})
export class ClientExistsValidatorDirective implements AsyncValidator, OnChanges, OnInit {
    private validator: AsyncValidatorFn;

    @Input()
    clientExists = true;

    @Input()
    docType: DocumentType;

    constructor(private getClientByDocumentUseCase: GetClientByDocumentUseCase) {}

    ngOnInit() {
        this.validator = clientExists(this.clientExists, this.docType, this.getClientByDocumentUseCase);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('clientExists' in changes || 'docType' in changes) {
            this.validator = clientExists(this.clientExists, this.docType, this.getClientByDocumentUseCase);
        }
    }

    validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return this.validator(c);
    }
}
